// Projects data.

const projects = [
	{
		id: 1,
		title: 'Beezy',
		slug: 'beezy',
		category: 'Web Application',
		img: require('@/assets/images/projects/beezy/landing.png'),
	},
	{
		id: 2,
		title: 'Arkivia',
		slug: 'arkivia',
		category: 'Web Application',
		img: require('@/assets/images/projects/arkivia/landing.svg'),
	},
	{
		id: 3,
		title: 'Scripto',
		slug: 'scripto',
		category: 'AI / Web Application',
		img: require('@/assets/images/projects/scripto/landing.jpg'),
	},
	{
		id: 4,
		title: 'Qui fait quoi?',
		slug: 'qui-fait-quoi',
		category: 'Data Migration',
		img: require('@/assets/images/projects/qui-fait-quoi/landing.jpg'),
	},
	{
		id: 5,
		title: 'Insectus',
		slug: 'insectus',
		category: 'Web Application',
		img: require('@/assets/images/projects/insectus/landing.png'),
	},
	{
		id: 6,
		title: 'Pollipro',
		slug: 'pollipro',
		category: 'Web Application',
		img: require('@/assets/images/projects/pollipro/landing.jpg'),
	},
];

export default projects;
